<template>
    <b-container class="sign-content-container">
        <b-row>
            <b-col><h1>Deine Daten</h1></b-col>
        </b-row>
        <b-row>
            <b-col>
                <p>Bitte wähle hier die Sparte aus und trage den Namen ein. <br class="d-none d-lg-block" />Sobald alles korrekt ist, klicke unten rechts auf "Weiter".</p>
                <p>Solltest Du Dich hier über das Formular nicht finden oder es Probleme geben, kannst Du uns eine E-Mail an <a href="mailto:info@stickerfive.de">info@stickerfive.de</a> senden oder unter <a href="tel:004989244169944">089 - 244 169 944</a> anrufen. <br />Wir helfen Dir dann gerne weiter.</p>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" sm="4">
                <b-form-select id="sportart" v-model="formData.section" :options="options" class="form-internal-margin"></b-form-select>
            </b-col>
            <b-col cols="12" sm="8">
                <vue-bootstrap-typeahead class="completebox form-internal-margin" :class="!formData.section ? 'input-disabled': ''"
                    :data="users"
                    v-model="userSearch"
                    :serializer="s => s.fullname"
                    placeholder="Name"
                    @hit="formData.name = $event"
                />
            </b-col>
            
        </b-row>
        <b-row>
            <b-col class="align-right"><b-button class="form-margin" :class="formData.section && formData.name ? ['sf-primary-button'] : ['sf-primary-button-outline', 'disabled']" @click="next">Weiter</b-button></b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {_} from 'vue-underscore';

    const API_URL = 'https://tsvploen-bestellung.stickerfive.de/backend/teamshoot/name?key=:query&section=:section'
    export default {
        name: "SignStep1",
        data: () => ({
            formData: {
                name: "",
                section: null
            },
            users: [],
            userSearch: '',
            isInvalid: true,
            options: [
                {
                    value: null,
                    text: 'Sportart'
                },
                {
                    value: 'SOCCER',
                    text: 'Fußball'
                },
                {
                    value: 'HANDBALL',
                    text: 'Handball'
                },
                {
                    value: 'KARATE',
                    text: 'Karate'
                }
            ]
        }),
        props: {
            user: {
                required: true
            }
        },
        watch: {
            'formData.name': function() {
                this.checkValidity();
            },
            'formData.section': function() {
                this.checkValidity();
            },
            // eslint-disable-next-line no-undef
            userSearch: _.debounce(function(addr) { this.getUsers(addr) }, 500)
        },
        methods: {
            next() {
                if(!this.isInvalid)
                    console.log(this.formData)
                    this.$emit('next', this.formData)
            },
            checkValidity() {
                console.log(this.formData.name);
                this.isInvalid = !(this.formData.name != undefined && this.formData.section != null);
            },
            async getUsers(query) {
                const res = await fetch(API_URL.replace(':query', query).replace(':section', this.formData.section))
                const suggestions = await res.json()
                this.users = suggestions
            }
        },
        created() {
            if (this.user.fullname && this.user.section) {
                console.log(this.user.fullname, this.user.section)
                this.userSearch = this.user.fullname
                this.formData.name = this.user.fullname
                this.formData.section = this.user.section
            }
        }
    }
</script>

<style lang="scss">
    .active {
        background-color: #E8C224 !important;
        border-color: #E8C224 !important;
    }
</style>
